@if (isUnified) {
  <!-- Unified Code: testimonials as content cards (not actionable, so no CTA). -->
  <section *ngIf="carouselResize.data.length" class="uc-home-section" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="uc-home-section__header">
        <h2 class="uc-home-section__title uc-display-sm" translate="home.testimonials"></h2>
      </div>
      <ul class="uc-card-grid uc-card-grid--3">
        <li *ngFor="let item of carouselResize.data">
          <figure class="uc-card uc-testimonial-card">
            <blockquote class="uc-testimonial-card__quote uc-text-md">{{ isRtl ? item.detailsAr : item.details }}</blockquote>
            <ngb-rating class="rating" [readonly]="true" [rate]="item.rate" [max]="5"
              [attr.aria-label]="'unifiedHome.card.rating' | translate: { rate: item.rate || 0 }"></ngb-rating>
            <figcaption class="uc-testimonial-card__author">
              <img loading="lazy" [src]="mediaUrl + item.imagePath" alt="">
              <span>
                <span class="uc-testimonial-card__name uc-text-md uc-semibold">{{ isRtl ? item.nameAr : item.name }}</span>
                <span class="uc-testimonial-card__job uc-text-sm">{{ isRtl ? item.jobTitleAr : item.jobTitle }}</span>
              </span>
            </figcaption>
          </figure>
        </li>
      </ul>
    </div>
  </section>
} @else {
<section *ngIf="carouselResize.data.length">
  <div class="container py-5">
    <h2 class="home-titles mb-5" translate="home.testimonials" [class]="isRtl ? 'text-end' : 'text-start'"></h2>
    <app-custom-carousel #appCustomCarousel [content]="testimonialsContent" [carouselResize]="carouselResize" (shareIndex)="carouselResize.currentIndex = $event" [showControls]="true" [showIndicators]="true" [distanceBetweenControlsIndicators]="true"></app-custom-carousel>
  </div>
  <ng-template #testimonialsContent>
    <div class="carousel-container w-100 position-relative overflow-hidden">
      <ng-container *ngFor="let slide of carouselResize.items; track i; let i = index">
        <div class="carousel-slide py-2 px-3 w-100 h-100 position-absolute" [ngStyle]="{left: 'calc('+ i +'*100%)', transform: 'translateX(-'+ carouselResize.currentIndex +'00%)'}">
          <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 h-100 justify-content-center">
            <div class="col text-center h-100" *ngFor="let item of slide">
              <div class="carousel-card bg-white d-flex flex-column align-items-center justify-content-between">
                <img loading="lazy" class="rounded-circle" [src]="mediaUrl + item.imagePath" [alt]="item.name">
                <h4 class="mb-0">{{isRtl? item.nameAr: item.name}}</h4>
                <span>{{isRtl? item.jobTitleAr: item.jobTitle}}</span>
                <p [dir]="isRtl ? 'rtl' : 'ltr'" class="mb-0"
                  [ngbTooltip]="isRtl? item.detailsAr: item.details">
                  {{isRtl? item.detailsAr: item.details}}
                </p>
                <ngb-rating class="rating" [readonly]="true" [rate]="item.rate" [max]="5"></ngb-rating>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</section>
}
